<template>
  <v-container fluid>
    <v-toolbar
      dark
      src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
    >
      <v-app-bar-nav-icon></v-app-bar-nav-icon>

      <v-toolbar-title>Dashboard Concept Version 2</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn @click="drawer = !drawer" icon>
        <v-icon>mdi-export</v-icon>
      </v-btn>
    </v-toolbar>
    <DashboardGrid />
    <v-navigation-drawer v-model="drawer" right absolute bottom>
      <v-btn @click="drawer = !drawer" icon>
        <v-icon>mdi-export</v-icon>
      </v-btn>
      <v-list nav dense>
        <v-list-item-group active-class="deep-purple--text text--accent-4">
          <v-list-item>
            <v-list-item-title>Foo</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>Bar</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>Fizz</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>Buzz</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
export default {
  name: "Dashboard",
  route: {
    path: "/dashboard-v2",
    name: "Dashboard V2",
  },
  components: {
    DashboardGrid: () => import("./components/DashboardGrid.vue"),
  },
  data() {
    return {
      drawer: false,
    };
  },
};
</script>

<style></style>
